import { getUseGetInvalidateInfiniteQuery } from './helpers/getGetUseInvalidateInfiniteQuery';
import { getUseGetInvalidateQuery } from './helpers/getUseGetInvalidateQuery';
import { getUseGetInfiniteQueryData } from './helpers/getUseInfiniteQueryData';
import { getUseGetQueryData } from './helpers/getUseQueryData';
import { getUseRefetchInfiniteQuery } from './helpers/getUseRefetchInfiniteQuery';
import { getUseRefetchQuery } from './helpers/getUseRefetchQuery';
import { getUseResetInfiniteQuery } from './helpers/getUseResetInfiniteQuery';
import { getUseResetQuery } from './helpers/getUseResetQuery';
import { getUseSetInfiniteQueryData } from './helpers/getUseSetInfiniteQueryData';
import { getUseSetQueryData } from './helpers/getUseSetQueryData';
import { getUseWrappedBatchQuery } from './helpers/getUseWrappedBatchQuery';
import { getUseWrappedInfiniteQuery } from './helpers/getUseWrappedInfiniteQuery';
import { getUseWrappedMutation } from './helpers/getUseWrappedMutation';
import { getUseWrappedMutationWithAxiosConfig } from './helpers/getUseWrappedMutationWithAxiosConfig';
import { getUseWrappedQuery } from './helpers/getUseWrappedQuery';
import { getUseWrappedQueryWithAxiosConfig } from './helpers/getUseWrappedQueryWithAxiosConfig';
export const createBosReactWrapper = ({ getAutofill, getUseQuery, getUseInfiniteQuery, getUseMutation, }) => (request, wrapperOptions) => {
    return {
        useQuery: getUseWrappedQuery({
            request,
            wrapperOptions,
            getAutofill,
            getUseQuery,
        }),
        useQueryWithAxiosConfig: getUseWrappedQueryWithAxiosConfig({
            request,
            wrapperOptions,
            getAutofill,
            getUseQuery,
        }),
        useQueryData: getUseGetQueryData(wrapperOptions),
        useGetInvalidateQuery: getUseGetInvalidateQuery(wrapperOptions),
        useRefetchQuery: getUseRefetchQuery(wrapperOptions),
        useResetQuery: getUseResetQuery(wrapperOptions),
        useSetQueryData: getUseSetQueryData(wrapperOptions),
        useInfiniteQuery: getUseWrappedInfiniteQuery({
            request,
            wrapperOptions,
            getAutofill,
            getUseInfiniteQuery,
        }),
        useInfiniteQueryData: getUseGetInfiniteQueryData(wrapperOptions),
        useGetInvalidateInfiniteQuery: getUseGetInvalidateInfiniteQuery(wrapperOptions),
        useRefetchInfiniteQuery: getUseRefetchInfiniteQuery(wrapperOptions),
        useResetInfiniteQuery: getUseResetInfiniteQuery(wrapperOptions),
        useSetIfiniteQueryData: getUseSetInfiniteQueryData(wrapperOptions),
        useBatchQuery: getUseWrappedBatchQuery({
            request,
            wrapperOptions,
            getAutofill,
            getUseQuery,
        }),
        useMutation: getUseWrappedMutation({
            request,
            getAutofill,
            getUseMutation,
        }),
        useMutationWithAxiosConfig: getUseWrappedMutationWithAxiosConfig({
            request,
            getAutofill,
            getUseMutation,
        }),
    };
};
